// import getOffsetRect from "Helpers/getOffsetRect.js";
// import windowWidth from "Helpers/windowWidth.js";

export default function Mapp(container) {
  const regions = container.querySelectorAll(".js-map-region");
  // const leftMin = 0;
  // const leftMax = 0;

  for (let i = 0, len = regions.length; i < len; i++) {
    initRegion(regions[i]);
  }

  window.addEventListener("resize", windowResizeHandler);

  // function getLeftMinValue() {}

  // function getLeftMaxValue() {}

  function initRegion(regionPath) {
    const popupId = regionPath.getAttribute("data-popup-id");
    const popupBlock = document.getElementById(popupId);
    let popupHeight = 0;
    const popupBlockStyle = popupBlock.style;

    regionPath.addEventListener("mouseenter", () => {
      popupBlock.classList.add("is-active");
      popupHeight = popupBlock.offsetHeight;
      regionPath.addEventListener("mousemove", regionMousemoveHandler);
    });

    regionPath.addEventListener("mouseleave", () => {
      regionPath.removeEventListener("mousemove", regionMousemoveHandler);
      popupBlock.classList.remove("is-active");
    });

    function regionMousemoveHandler(e) {
      popupBlockStyle.left = `${e.pageX}px`;
      popupBlockStyle.top = `${e.pageY - (popupHeight + 25)}px`;
    }
  }

  function windowResizeHandler() {}
}
